<template>
  <div class="wrap">
    <Nav fixed safeAreaInsetTop placeholder left @leftClick="$router.push('/tabbar/goods')" />
    <div class="content">
      <div class="header_title">{{ $t('user.basicInformation') }}</div>
      <div class="form">
        <div class="userInfo">
          <div class="info_item">
            <div class="label">{{ $t('whatJob') }}:</div>
            <van-field v-model="form.job" label-width="0" :placeholder="$t('whatJobPlaceholder')" />
          </div>
          <div class="info_item">
            <div class="label">{{ $t('howMany') }}:</div>
            <van-field v-model="form.allIncome" label-width="0" :placeholder="$t('facebookLinkPlaceholder')" />
          </div>
          <div class="info_item">
            <div class="label">{{ $t('howMuch') }}:</div>
            <van-field v-model="form.Allexpenditure" label-width="0" :placeholder="$t('facebookLinkPlaceholder')" />
          </div>
          <div class="info_item">
            <div class="label">{{ $t('whatLoan') }}:</div>
            <van-field v-model="form.jobAddress" label-width="0" :placeholder="$t('facebookLinkPlaceholder')" />
          </div>
          <div class="info_item">
            <div class="label">{{ $t('haveEver') }}:</div>
            <van-radio-group v-model="form.isEver" direction="horizontal">
              <van-radio name="0">{{ $t('yes') }}</van-radio>
              <van-radio name="1">{{ $t('no') }}</van-radio>
            </van-radio-group>
          </div>
          <div class="info_item">
            <div class="label">{{ $t('areLoan') }}:</div>
            <van-radio-group v-model="form.isOkay" direction="horizontal">
              <van-radio name="0">{{ $t('yes') }}</van-radio>
              <van-radio name="1">{{ $t('no') }}</van-radio>
            </van-radio-group>
          </div>
        </div>
      </div>
      <div class="btn" @click="submit">{{ $t('user.Button.Two') }}</div>
    </div>
  </div>
</template>
<script>
import { Icon, Toast, Field, RadioGroup, Radio } from "vant";
import Nav from "@/components/Navbar";
import { USER_LEVELAUTH } from "@/api";
export default {
  components: {
    [Icon.name]: Icon,
    Nav,
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
  },
  data() {
    return {
      form: {
        level: 2,
        job: '',
        allIncome: '',
        Allexpenditure: '',
        jobAddress: "",
        isEver: '0',
        isOkay: '0'
      },
    }
  },
  created() {
    this.getData();
  },
  methods: {
    submit() {
      if (!this.form.job) return this.$toast(this.$t('jobError'));
      if (!this.form.allIncome) return this.$toast(this.$t('manyError'));
      if (!this.form.Allexpenditure) return this.$toast(this.$t('muchError'));
      if (!this.form.jobAddress) return this.$toast(this.$t('purposeError'));
      this.setLevelAuth()
    },
    async getData() {
      try {
        const res = await USER_LEVELAUTH({});
        this.form = { ...this.form, ...res.data.auth_data || {} }
      } catch (error) { }
    },
    async setLevelAuth() {
      try {
        const res = await USER_LEVELAUTH(this.form);
        this.$router.push('/wallet')
      } catch (error) {
        this.$toast(error.msg)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background-color: var(--nav-background);
  display: flex;
  flex-direction: column;

  .content {
    padding: calc(15rem / 16);
    padding-bottom: calc(90rem / 16);

    .header_title {
      color: var(--white);
      text-align: center;
      display: block;
      font-size: calc(28rem / 16);
      font-weight: 700;
      padding-bottom: calc(15rem / 16);
    }

    .form {
      .userInfo {
        margin-top: calc(10rem / 16);
        padding: calc(10rem / 16);
        border-radius: calc(10rem / 16);
        color: var(--white);
        background: linear-gradient(179.61deg, #f37e00 -16.96%, #ffca73 53.7%, rgba(255, 202, 115, 0) 95.96%);
        background-size: contain;
        background-position: bottom;

        .info_item {
          margin: calc(10rem / 16) 0;

          .label {
            padding-bottom: calc(10rem / 16);
            font-size: calc(14rem / 16);
          }

          /deep/ .van-cell {
            height: calc(45rem / 16);
            line-height: calc(45rem / 16);
            padding: 0 calc(16rem / 16);
            border-radius: calc(5rem / 16);

            .van-field__body {
              input {
                color: #606266;
                font-size: calc(14rem / 16);
              }
            }
          }

          /deep/ .van-radio-group {
            padding-bottom: calc(10rem / 16);

            .van-radio__icon {
              font-size: calc(14rem / 16);
            }

            .van-radio--horizontal {
              margin-right: 20%;
            }

            .van-radio__icon--checked .van-icon {
              color: var(--moduleColor);
              background-color: var(--white);
              border-color: var(--white);
            }

            .van-radio__label {
              color: var(--white);
              font-size: calc(14rem / 16);
            }
          }
        }
      }
    }

    .btn {
      position: fixed;
      bottom: calc(20rem / 16);
      left: calc(20rem / 16);
      right: calc(20rem / 16);
      background: #f96;
      border: none;
      height: calc(50rem / 16);
      border-radius: calc(8rem / 16);
      color: var(--white);
      text-align: center;
      line-height: calc(50rem / 16);
      font-size: var(18rem / 16);
    }
  }
}
</style>